import { cn } from 'lib/utils';
import { uiSimpleBox } from '../CutCorners';
import { FC, useState } from 'react';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';

interface BPRainbowBoxProps {
  showBg?: boolean;
  showGlow?: boolean;
  cycleHue?: boolean;
  className?: string;
}

const BPRainbowBox: FC<BPRainbowBoxProps> = ({
  showBg = true,
  showGlow = true,
  cycleHue = false,
  className,
}) => {
  const [hueRotation, setHueRotation] = useState(0);
  const rotate = { value: 0 };

  useGSAP(() => {
    if (!cycleHue) return;
    gsap.to(rotate, {
      value: 360,
      duration: 5,
      ease: 'linear.none',
      repeat: -1,
      onUpdate: () => setHueRotation(rotate.value),
    });
  }, [cycleHue]);

  return (
    <>
      {showGlow && (
        <div
          className="block absolute w-[calc(100%+20px)] h-[calc(100%+20px)] top-[-10px] left-[-10px] bg-gradient-to-tr from-bionic-green to-[#FC7038] via-[#0BB4FF_25%,_#FB439C_72%] rounded-[10px] opacity-30"
          style={{
            filter: `hue-rotate(${Math.round(hueRotation)}deg) blur(30px)`,
          }}
        />
      )}
      {showBg && (
        <div
          className={cn(
            'block absolute top-0 left-0 w-full h-full bg-bionic-greyDark/90',
            uiSimpleBox.bg
          )}
        />
      )}
      <div
        className={cn(
          'block absolute top-0 left-0 w-full h-full bg-gradient-to-tr from-bionic-green to-[#FC7038] via-[#0BB4FF_25%,_#FB439C_72%]',
          uiSimpleBox.border,
          className ? className : ''
        )}
        style={{ filter: `hue-rotate(${Math.round(hueRotation)}deg)` }}
      />
    </>
  );
};

export default BPRainbowBox;
